import { getCustomerLocationLabel } from './locations';

/**
 * The template table's own filter. Local — it searches the rows already in
 * hand, not the API — and it reaches into each template's assigned locations
 * so an admin can find a template by the customer it serves.
 */
export const filterTemplates = <T extends { name?: string; capacityLabel?: string }>(
  rows: T[],
  query: string
): T[] => {
  const search = query.trim().toLowerCase();

  if (!search) {
    return rows;
  }

  return (rows || []).filter((row: any) => {
    const assignedLocationText = (row.assignedLocations ?? [])
      .map((location: any) => {
        const { customerName, customerEmail, locationName, address } =
          getCustomerLocationLabel(location);

        return [customerName, customerEmail, locationName, address].filter(Boolean).join(' ');
      })
      .join(' ');

    return [row.name, row.capacityLabel, assignedLocationText].some((value) =>
      String(value ?? '')
        .toLowerCase()
        .includes(search)
    );
  });
};
